export default "__VITE_ASSET__ByPiXRBY__"